import React from 'react';

import Main from '../../Layouts/Main';

import Filters from '../../components/Filters/Filters';

import Cities from '../../components/Cities/Cities';

import Mouse from '../../assets/mouse-white.svg';

import './Home.css';


function Home() {
  return (
    <Main menuTransparent>
      <div className="home">
        <header className="filters">
          <div className="container">
            <h1>AMORC EM SUA CIDADE</h1>
            <Filters />
            <div className="bounce">
              <img src={Mouse} alt="" />
            </div>

          </div>
        </header>
        <div className="text-center bg-gray">
          <div className="container" style={{ paddingBottom: '10vh' }}>
            <h2 style={{ paddingBottom: '10vh', paddingTop: '10vh' }}>Cidades mais próximas</h2>
            <Cities />
          </div>
        </div>
        <div className="afiliado text-center container" style={{ paddingBottom: '10vh', paddingTop: '10vh' }}>
          <h2>Visite a Área do Afiliado</h2>
          <p>Fique por dentro das novidades sobre a Ordem Rosacruz, promoções, eventos e acesse suas monografias online.</p>
          <a href="https://afiliado.amorc.org.br" target="_blank" rel="noopener noreferrer">
            <button type="button" className="btn btn-primary big-button">
              VISITAR
            </button>
          </a>
        </div>

      </div>
    </Main>

  );
}


export default Home;
